export const RECAPTCHA_KEY = '6Le-dkgdAAAAAENszP9cdZU-mya_JObjB143hkXm';
export const RECAPTCHA_KEY_V2 = '6LfKRFQdAAAAAHAZ-S_kAbFPtNK8ufkmQUoo8EkV';

export const RECAPTCHA_ERROR_CODE = 'LowScoreRecaptchaToken';

const recaptchaActions = [
    'ADD_EMAIL_EXTERNAL_ACCESS',
    'AUTOFILL_REQUEST',
    'BANKING_DEPOSIT',
    'BANKING_DICT_REQUEST',
    'BANKING_EXTERNAL_ACCOUNT_CREATION',
    'BANKING_RESOURCE_VERIFICATION',
    'BANKING_WITHDRAWAL',
    'CONFIRM_VERIFICATION',
    'CREATE_CONTRACT_PARTY',
    'CREATE_CONTRACT',
    'DELETE_CONTRACT_PARTY',
    'EMAIL_VALIDATION_REQUEST',
    'GET_CONTRACT_EVENTS',
    'GOOGLE_AUTHORIZATION',
    'GUEST_LOGIN',
    'LISTING_PICTURES_DOWNLOAD',
    'LOGIN',
    'MFA',
    'CREATE_CREDIT_CARD',
    'PASSWORD_RECOVERY_UPDATE',
    'PASSWORD_RECOVERY',
    'PATCH_CONTRACT',
    'POINT_ORDER_REQUEST',
    'PURCHASE_SCREENING',
    'REGISTER',
    'RENTAL_BILLING_CC_PAYMENT',
    'RENTAL_BILLING_CC_CREATE_CUSTOMER',
    'RENTAL_BILLING_CC_GET_CUSTOMER',
    'RENTAL_BILLING_CC_GET_CARD',
    'RENTAL_CONTRACT_CREATION',
    'RENTAL_CONTRACT_PATCH',
    'RENTAL_LANDLORD_AUTOFILL',
    'RENTAL_LANDLORD_CREATION',
    'REQUEST_VERIFICATION',
    'RESOURCE_VERIFICATION',
    'SCREENING_REPORT_DOWNLOAD',
    'TOKEN_ACCESS',
    'TOO_GRANT_EXTERNAL_ACCESS',
    'TOO_INSURANCE_QUOTE',
    'VERIFICATION_ISSUING',
    'VERIFY_EMAIL_EXTERNAL_ACCESS',
    'WORKSPACE_INVITE_DELETE_REQUEST',
    'WORKSPACE_INVITE_GET_REQUEST',
    'RENTAL_BILLING_CC_PAYMENT',
    'RENTAL_BILLING_CC_CREATE_CUSTOMER',
    'RENTAL_BILLING_CC_GET_CUSTOMER',
    'RENTAL_BILLING_CC_GET_CARD',
    'RENTAL_BILLING_CC_UPDATE_CARD',
] as const;

export type RecaptchaActions = (typeof recaptchaActions)[number];
